var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.172 14.358V3.371l22.275 22.437c-.462.38-6.02 4.826-12.643 2.85-5.749-1.727-9.832-7.586-9.632-14.299zm26.97 3.291.03 10.906L6.829 6.2c.461-.39 6.01-4.855 12.632-2.899 5.78 1.717 9.883 7.597 9.673 14.35h.01z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnt);
export default __webpack_public_path__ + "static/media/ONT.bd16f9c76f4b7d2a603096e53a9c01df.svg";
export { ForwardRef as ReactComponent };